const { Box, Typography } = require("@mui/material");

const DetailList = ({ title, data, icon, textStyle, style }) => {
  return (
    <Box sx={{ display: "flex", mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          width: "100%",
          alignItems: "center",
          ...style,
        }}
      >
        {icon}
        <Typography sx={{ fontSize: 17, color: "rgba(0,0,0,0.7)" }}>
          {title}
        </Typography>
      </Box>
      <Typography sx={{ fontSize: 17, width: "100%", ...textStyle }}>
        {data}
      </Typography>
    </Box>
  );
};

export default DetailList;
